import React from 'react';
import './About.css'; 

export default function About() {
  return (
    <div className="about-container">
      <div className="about-left">
        <p>
            Claire Bian, multidisciplinary artist and aspiring software engineer based in New York City. Currently pursuing a B.A. in Computer and Data Science with a minor in Interactive Media Arts at New York University.
        </p>
      </div>
      <div className="about-right">
        <img src="/bunni.png" alt="Bunni" className="about-image" />
      </div>
    </div>
  );
}
